import { getAddress } from "viem"

export const vaults = new Map([
  [
    getAddress("0xa8A02E6a894a490D04B6cd480857A19477854968"),
    {
      name: "Euler Linea wstETH WETH",
      description: "Component of the Euler Linea wstETH Cluster",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x359e363c11fC619BE76EEC8BaAa01e61D521aA18"),
    {
      name: "Euler Linea wstETH wstETH",
      description: "Component of the Euler Linea wstETH Cluster",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xF4712fC5E6483DE9e1Ff661D95DD686664327086"),
    {
      name: "Euler Linea weETH WETH",
      description: "Component of the Euler Linea weETH Cluster",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x8955d7dCdE9bD9694B64732aD28fF2113eb217B4"),
    {
      name: "Euler Linea weETH weETH",
      description: "Component of the Euler Linea weETH Cluster",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x8bf8EdC911Ab3f0ea4a27c51Cb88b57ccE5356f1"),
    {
      name: "Euler Linea ezETH WETH",
      description: "Component of the Euler Linea ezETH Cluster",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x873FEA936C29C8a9f3e0D7caCFC1Dc46E2A93e56"),
    {
      name: "Euler Linea ezETH ezETH",
      description: "Component of the Euler Linea ezETH Cluster",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x179DfD3eCDC6f5B8F8788584F3289D10c6F1afb8"),
    {
      name: "Euler Linea wrsETH WETH",
      description: "Component of the Euler Linea wrsETH Cluster",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x5DF4080d8d1a85457d699E6a85255fc4087B8Abf"),
    {
      name: "Euler Linea wrsETH wrsETH",
      description: "Component of the Euler Linea wrsETH Cluster",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x14EfcC1Ae56e2fF75204Ef2Fb0DE43378d0beaDA"),
    {
      name: "ZeroLend USDC",
      description: "Component of the ZeroLend Linea Cluster",
      entity: "zerolend",
    },
  ],
  [
    getAddress("0x085f80Df643307e04f23281F6fdbfAA13865E852"),
    {
      name: "ZeroLend USDT",
      description: "Component of the ZeroLend Linea Cluster",
      entity: "zerolend",
    },
  ],
  [
    getAddress("0x9aC2F0A564B7396A8692E1558d23a12d5a2aBb1F"),
    {
      name: "ZeroLend WETH",
      description: "Component of the ZeroLend Linea Cluster",
      entity: "zerolend",
    },
  ],
  [
    getAddress("0xf3C6598A9Bc60771dCd4dD448Fb56122B7f8588a"),
    {
      name: "ZeroLend LINEA",
      description: "Component of the ZeroLend Linea Cluster",
      entity: "zerolend",
    },
  ],
  [
    getAddress("0x64623F8617F0019FC155a84c5061b472577d23d0"),
    {
      name: "ZeroLend mUSD",
      description: "Component of the ZeroLend Linea Cluster",
      entity: "zerolend",
    },
  ],
  [
    getAddress("0xb135dcF653DAFB5ddAa93F926D7000Aa3222EFEE"),
    {
      name: "Re7 Labs WETH Cluster WETH",
      description: "Component of the Re7 Labs WETH Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xB770dc4be757Ad72BCb7b8FF4958FB5c6Ee5Aa49"),
    {
      name: "Re7 Labs WETH Cluster wstETH",
      description: "Component of the Re7 Labs WETH Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xb747b627C3b67cDC0Aeaf78FD7174aE5E5Bfa796"),
    {
      name: "Re7 Labs WETH Cluster wrsETH",
      description: "Component of the Re7 Labs WETH Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x9947f3D2aE676bE4612Eb4d80e94f6441E47A2a9"),
    {
      name: "Re7 Labs WETH Cluster ezETH",
      description: "Component of the Re7 Labs WETH Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x92Ba0dED54184ab00f7EdD1bc5Eba488cC8d9dE0"),
    {
      name: "Re7 Labs WETH Cluster weETH",
      description: "Component of the Re7 Labs WETH Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xfB6448B96637d90FcF2E4Ad2c622A487d0496e6f"),
    {
      name: "Re7 Labs USD Cluster USDC",
      description: "Component of the Re7 Labs USD Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xb11FD944Cf5E8678B5Db42305aff03B7942A3CaB"),
    {
      name: "Re7 Labs USD Cluster WBTC",
      description: "Component of the Re7 Labs USD Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xA7ada0D422a8b5FA4A7947F2CB0eE2D32435647d"),
    {
      name: "Re7 Labs USD Cluster mUSD",
      description: "Component of the Re7 Labs USD Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xCBeF9be95738290188B25ca9A6Dd2bEc417a578c"),
    {
      name: "Re7 Labs USD Cluster USDT",
      description: "Component of the Re7 Labs USD Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x42267dC26FCece525F04E75dA3fA596f88ceDDe0"),
    {
      name: "Re7 Labs USD Cluster wsrUSD",
      description: "Component of the Re7 Labs USD Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x5464cC940BeFf4301eD21DF535761546F19De2D3"),
    {
      name: "Re7 Labs USD Cluster REX33",
      description: "Component of the Re7 Labs USD Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x54A4dC1Df3861166c976EAA5A66b4d2DCc7E7f55"),
    {
      name: "Re7 Labs USD Cluster yUSD",
      description: "Component of the Re7 Labs USD Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xE27C2571F6D1b942bBB438a37b0171C64B469e1F"),
    {
      name: "Edge UltraYield USDC",
      description:
        "A USDC vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0x4789D8066Cac17fd24F24206a49aBC72830604F1"),
    {
      name: "Edge UltraYield WETH",
      description:
        "A WETH vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0x3cc7963fa503fe32053f177c444855a71068A839"),
    {
      name: "Edge UltraYield wstETH",
      description:
        "A wstETH vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0x140bD9A62Ba84fbF78d9e3dd4A94FdaFC999FAF5"),
    {
      name: "Edge UltraYield wrsETH",
      description:
        "A wrsETH vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0x1dA14e692956382804A06Ce38B984f56DE457D7d"),
    {
      name: "Edge UltraYield weETH",
      description:
        "A weETH vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
])
